/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../graphql-types.gen';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type GetEventByIdQueryVariables = Exact<{
  id: number;
}>;


export type GetEventByIdQuery = { events: { items: Array<{ id: number, title: string, date: string | null | undefined, location: string | null | undefined, image_url: string | null | undefined, short_description: string | null | undefined, long_description: string | null | undefined } | null | undefined> } | null | undefined };

export declare const GetEventById: import("graphql").DocumentNode;
export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetEventByIdDocument = new TypedDocumentString(`
    query GetEventById($id: Int!) {
  events(filter: { id: $id }) {
    items {
      id
      title
      date
      location
      image_url
      short_description
      long_description
    }
  }
}
    `) as unknown as TypedDocumentString<GetEventByIdQuery, GetEventByIdQueryVariables>;